import React from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { aboutInfo } from '../mock';

export default function About() {
  return (
    <div>
      <div className="relative h-[46vh] min-h-[340px] bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1589946897136-bd7ba00782a6?crop=entropy&cs=srgb&fm=jpg&q=85)` }}>
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">About Us</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">Our Story</h1>
        </div>
      </div>

      <section className="section">
        <div className="container-x grid md:grid-cols-2 gap-14 items-start">
          <Reveal>
            <SectionHeader eyebrow="Established 2014" title={aboutInfo.title} subtitle={aboutInfo.body} />
            <p className="text-[#5c4020] leading-relaxed mb-4">
              The safari was conceived as a conservation reserve to protect and breed the endangered Asiatic Lion (Panthera leo persica). Situated in the heartland of Uttar Pradesh, the park now sprawls across nearly 350 hectares of woodland along the Etawah–Gwalior road.
            </p>
            <p className="text-[#5c4020] leading-relaxed">
              Beyond the flagship lions, the park is home to leopards, sloth bears, blackbucks, spotted deer, sambar, and hundreds of resident and migratory birds. Guided safaris in eco-friendly vehicles offer visitors an intimate glimpse into their natural way of life.
            </p>
          </Reveal>

          <Reveal delay={150}>
            <div className="grid grid-cols-2 gap-4">
              <img src="https://images.unsplash.com/photo-1745933446961-13b251020d58?crop=entropy&cs=srgb&fm=jpg&q=85" className="rounded-lg h-64 object-cover shadow-md" alt="lion" />
              <img src="https://images.unsplash.com/photo-1651663513258-1528b7b173d5?crop=entropy&cs=srgb&fm=jpg&q=85" className="rounded-lg h-64 object-cover shadow-md mt-8" alt="lion" />
              <img src="https://images.unsplash.com/photo-1682848310112-be63321ce3d0?crop=entropy&cs=srgb&fm=jpg&q=85" className="rounded-lg h-64 object-cover shadow-md" alt="landscape" />
              <img src="https://images.unsplash.com/photo-1562183667-a159d28118ec?crop=entropy&cs=srgb&fm=jpg&q=85" className="rounded-lg h-64 object-cover shadow-md mt-8" alt="safari" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section bg-[#fbf3e4]">
        <div className="container-x">
          <SectionHeader center eyebrow="Vision & Mission" title="Committed to Conservation" subtitle="We are dedicated to safeguarding India's magnificent wildlife heritage for generations to come." />
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { t: 'Conservation', d: 'Protecting endangered species and their natural habitats through in-situ conservation.' },
              { t: 'Education', d: 'Inspiring appreciation for wildlife via interpretation centres and guided experiences.' },
              { t: 'Community', d: 'Supporting local communities through eco-tourism, employment and awareness.' },
            ].map((c, i) => (
              <Reveal key={c.t} delay={i * 120}>
                <div className="bg-white p-8 rounded-lg border border-[#e6d3b0] h-full hover:shadow-lg transition-shadow">
                  <div className="font-display text-3xl text-[#b8791c] mb-2">0{i + 1}</div>
                  <h3 className="font-display text-2xl text-[#2b1d0e] mb-2">{c.t}</h3>
                  <p className="text-sm text-[#5c4020] leading-relaxed">{c.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
